import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DetailOrderRequest, OrderClientRequest, OrderRequest } from 'src/app/models/order.model';
import { ProductResponse } from 'src/app/models/product.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { OrderService } from 'src/app/services/order.service';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { InvoiceSaleService } from '../../pages/inventory/sales/invoice-sale/invoice-sale.service';
import { VendorResponse } from 'src/app/models/vendor.model';
import { OrderClientService } from 'src/app/services/order-client.service';

@Component({
  selector: 'app-modal-create-order-v2',
  templateUrl: './modal-create-order-v2.component.html',
  styleUrls: ['./modal-create-order-v2.component.scss']
})
export class ModalCreateOrderV2Component implements OnInit {
  loading = false;
  date = new Date();
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  newOrder: OrderClientRequest = new OrderClientRequest();
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        price: null
      }
    },
    client: {
      value: 'CF',
      verified: true,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'success',
      tooltip: 'status-client',
      data: { id: null }
    },
  };

  vendors = [];
  filterClients = [];
  filterAffiliates = [];
  isAffiliate = true;
  currentClient: VendorResponse;
  options = {
    selected: "invoice",
    invoice: { serie: null, number: null, type: undefined, types: [], email: null },
    doc: { number: null },
    electronicInvoice: true,
    exportInvoice: false,
    sendEmail: true,
    download: true,
    normalDownload: true
  }

  creditClient: number = 0;
  creditAvailable: number = 0;
  stateCheckbox = false;

  warehouses: WarehouseResponse[] = [];
  products: ProductResponse[] = [];
  filterWarehouses: WarehouseResponse[] = [];
  filterProducts: ProductResponse[] = [];
  timeout = null;
  quantity = 0;
  productList = [];
  allowedWarehouses: { [key: number]: boolean } = {};

  constructor(
    private warehouseService: WarehouseService,
    private productService: ProductService,
    private toastService: ToastrService,
    private orderService: OrderService,
    private orderClientService: OrderClientService,
    private authService: AuthenticationService,
    private invoiceSaleService: InvoiceSaleService,
  ) {
    var getUserPosition = authService.getUserPosition();
    if (getUserPosition) {
      getUserPosition.forEach((u) => {
        if (u.warehouse != 0) {
          this.allowedWarehouses[u.warehouse] = true;
        }
      });
    }
  }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getWarehouses("");
    this.getProducts("");
    this.getClients();
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  getWarehouses(clue) {
    this.warehouseService.getWarehouseByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses.filter((w) => {
          return this.allowedWarehouses[w.id];
        });
        if (this.filterWarehouses.length == 0) {
          this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        } else if (this.filterWarehouses.length == 1) {
          this.changeInput(this.inputs.warehouse, this.filterWarehouses[0].name, true, null, 'fa-circle-check', this.filterWarehouses[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data

        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  getClients() {
    this.invoiceSaleService.getClients().subscribe({
      next: (response: ResponseObject) => {
        this.vendors = response.data;
        this.filterClients = this.vendors;
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.client, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    })
  }

  getClient() {
    this.invoiceSaleService.getClientsByNit("cf").subscribe({
      next(response: ResponseObject) {
        console.log(response);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  addProduct() {
    this.productService.getExistence(this.inputs.warehouse.data.id, this.inputs.product.data.id).subscribe({
      next: (response: ResponseObject) => {
        const existences = response.data;
        console.log(existences);

        this.productList.push({ productData: this.inputs.product.data, quantity: this.quantity, reserve: false, price: 0.00, existences: existences, waiting: 0 });
        this.inputs.product.value = "";
        this.quantity = 0;
        this.getProducts('');
      },
      error: (err: HttpErrorResponse) => {
        this.toastService.error(`Error al obtener las existencias del producto: ${this.filterProducts[0].name}`, "Error");
      }
    });
  }

  deleteProductFromList(index: number) {
    this.productList.splice(index, 1);

  }

  writeWarehouse(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.warehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.getWarehouses(inputValue);
    }, 500);
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: WarehouseResponse) {
    this.changeInput(this.inputs.product, product.code + " - " + product.name, true, null, "fa-circle-check", product);
  }

  get totalOrder(): number {
    return this.productList.reduce(
      (sum, item) => sum + item.quantity * item.price,
      0
    ).toFixed(2);
  }

  get totalCreditAvailable() {
    if (this.productList && this.productList.length > 0) {
      const calculateTotal: number = this.productList.reduce(
        (sum, item) => sum + item.quantity * item.price,
        0
      );
      return (this.creditAvailable - calculateTotal).toFixed(2);
    } else {
      if (this.creditAvailable) {
        return this.creditAvailable;
      }
      return 0.00;
    }
  }

  createOrder() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.newOrder.detail = [];
    this.productList.forEach((p) => {
      this.newOrder.detail.push(new DetailOrderRequest(p.productData.id, p.quantity, p.reserve, p.price));
    })
    this.newOrder.creationDate = new Date(this.date).getTime();
    this.newOrder.warehouseId = this.inputs.warehouse.data.id;
    this.newOrder.clientId = this.currentClient.id;
    console.log(this.newOrder);

    this.orderClientService.addOrderClient(this.newOrder).subscribe({
      next: (response: ResponseObject) => {
        this.newOrder = new OrderClientRequest();
        this.toastService.success("Pedido creado correctamente!");
        this.loading = false;
        this.closed.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit();
  }

  close() {
    this.closed.emit();
    this.showModal = false;
  }

  searchClient(inputValue: string) {
    let temp: any = this.vendors.filter((client) => {
      if (inputValue.toLowerCase() == 'cf' || inputValue.toLowerCase() == 'c/f') {
        return client.code.toLowerCase() == 'vcf';
      } else {
        return client.name.toLowerCase().includes(inputValue.toLowerCase()) || (client.id + "") == (inputValue) ||
          client.nit.toLowerCase().includes(inputValue.toLowerCase());
      }
    }
    );
    this.filterClients = temp;
    if (temp.length == 1) {
      this.changeStatusInputClient(temp[0], temp[0].nit + " - " + temp[0].name, 1);
    } else {
      if (temp.length == 0) {
        this.inputs.client.class = "typing";
        this.invoiceSaleService.getClientsByNit(inputValue).subscribe({
          next: (response: ResponseObject) => {
            if (response) {
              this.vendors.push(response.data);

              this.changeStatusInputClient(response.data, response.data.nit + " - " + response.data.name, 1);
            } else {
              this.toastService.info("El cui enviado no es valido");
              this.changeStatusInputClient(null, inputValue, 0);
            }
          },
          error: (error: HttpErrorResponse) => {
            this.changeStatusInputClient(null, inputValue, 0);
            this.toastService.error(error.error.message);
          }
        });
      } else {
        this.inputs.client.class = "fa-list";
        this.inputs.client.verified = false;
        this.inputs.client.data = null;
      }
    }
  }

  changeStatusInputClient(selected: any, newValue: string, status: number) {
    let tempInput = this.inputs.client;

    tempInput.verified = status === 1;
    this.currentClient = selected;

    this.invoiceSaleService.getClientCredit(selected.id).subscribe({
      next: (response) => {
        if (response.data.availableClientCredit != null) {
          this.creditAvailable = response.data.availableClientCredit;
        } else {
          this.creditAvailable = 0;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastService.error(`No se puedo obtener el credito del cliente: ${selected.nit}`, "Error")
      }
    });

    if (status === 1) {
      tempInput.data = selected;
      tempInput.value = newValue;
      tempInput.color = "success";
      tempInput.class = "fa-circle-check";

      // Asignar email del cliente al invoice
      this.options.invoice.email = selected.contactMail;

      // Validar si el cliente es afiliado
      this.invoiceSaleService.validateAffiliate(selected.id).subscribe({
        next: (response) => {
          this.isAffiliate = Object(response)["data"];

          // Si es afiliado, cargar lista de afiliados
          this.invoiceSaleService.getAffiliateByClue("").subscribe({
            next: (response: ResponseObject) => {
              this.filterAffiliates = response.data;
            },
            error: (error: any) => {
              console.error(error);
            }
          });
        },
        error: (error) => {
          console.error("Fail to get affiliate validation", error);
        }
      });

    } else {
      // Resetear input cuando no es válido
      tempInput.data = null;
      tempInput.color = "danger";

      if (status === 0) {
        tempInput.class = "fa-xmark";
      } else {
        tempInput.class = "fa-asterisk";
      }
    }
  }


  handleInput(event: any, type: string) {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value;
    const input = event.target as HTMLInputElement;
    const parentInput = input.parentElement;
    const divElements = parentInput.getElementsByClassName('suggestions')[0];
    divElements.classList.add('suggestions-show');
    if (type == 'client') {
      clearTimeout(this.timeout);
      this.inputs.client.class = "typing";
      this.timeout = setTimeout(() => {
        this.searchClient(inputValue);
      }, 500);
    }
  }

  onCheckboxChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.productList.forEach(element => {
      element.reserve = checked;
    });
  }

}